const headers = [
  {
    text: 'id',
    value: 'platformId',
    sortable: false,
    width: '3%'
  },
  {
    text: 'jd.jd_jdcom-store-name',
    value: 'name',
    sortable: false,
    width: '70%'
  },
  {
    text: 'jd.jd_platform-country',
    value: 'country',
    sortable: false,
    width: '9%'
  },
  {
    text: 'common.input_sort-number',
    value: 'sortNumber',
    sortable: false,
    width: '9%'
  },
  {
    text: 'payment.payment_operation',
    value: 'edit',
    sortable: false,
    width: '9%'
  }
]
export default { headers }
